"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import ElPhoneVerifyCodeInput from "../framework/components/form/ElPhoneVerifyCodeInput.vue";
import API from "@ym-framework/api-utils";
import MainLayout from "../MainLayout.vue";
import Validator from "../framework/components/form/validator";
import { WEB_HTML } from "@/configuration/websocketskey";
let ForgetPassword = class extends Vue {
  constructor() {
    super(...arguments);
    this.status = "ready";
    this.rules = {
      phone: [
        { required: true, message: this.$t("forget_password.phone_validator"), trigger: "blur" },
        { validator: Validator.phone, trigger: "blur" }
      ],
      password: [
        { required: true, message: this.$t("forget_password.password_validator"), trigger: "blur" },
        { validator: Validator.password, trigger: "blur" }
      ],
      verify_code: [
        { required: true, message: this.$t("forget_password.code_validator"), trigger: "blur" },
        { validator: Validator.no_empty, trigger: "blur", message: this.$t("forget_password.code_validator") }
      ]
    };
    this.formData = {
      phone_prefix: "+86",
      phone: "",
      password: "",
      verify_code: ""
    };
  }
  sendPhoneCode(lock) {
    return __async(this, null, function* () {
      try {
        let validPhone = true;
        yield this._selfForm.validateField("phone", (errorMessage) => {
          validPhone = errorMessage === "";
        });
        if (validPhone) {
          yield API.post("api://base.app/api/v1/verify_code/send", {
            "phone_prefix": this.formData.phone_prefix,
            "code_type": 2,
            "phone": this.formData.phone
          });
          this.$message(this.$t("forget_password.phone_code_send_tip_1") + this.formData.phone + this.$t("forget_password.phone_code_send_tip_2"));
          lock(120);
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        if (yield this._selfForm.validate()) {
          this.status = "submit";
          yield API.post("api://base.app/api/v1/accounts/forgetpassword/auth", {
            "phone_prefix": this.formData.phone_prefix,
            "new_password": this.formData.password,
            "phone": this.formData.phone,
            "verify_code": this.formData.verify_code
          });
          this.$message.success(this.$t("forget_password.edit_password_success"));
          this._phone_verify_code.clearLock();
          setTimeout(() => {
            window.open(`${WEB_HTML}/home`, "_self");
          }, 3e3);
        }
      } catch (error) {
        this.status = "ready";
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("selfForm")
], ForgetPassword.prototype, "_selfForm", 2);
__decorateClass([
  Ref("phone_verify_code")
], ForgetPassword.prototype, "_phone_verify_code", 2);
ForgetPassword = __decorateClass([
  Component({
    components: {
      PasswordInput,
      ElPhoneVerifyCodeInput,
      MainLayout
    }
  })
], ForgetPassword);
export {
  ForgetPassword as default
};
